import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressComponent } from './progress/progress.component';
import { NextPrevComponent } from './next-prev/next-prev.component';
import { CoverageDetailsComponent } from './coverage-details/coverage-details.component';
import { CoverageTabsComponent } from './coverage-tabs/coverage-tabs.component';
import { PersonalDetailsComponent } from './personal-details/personal-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UnderwritingTermsComponent } from './underwriting-terms/underwriting-terms.component';
import { RemoveCoverComponent } from './remove-cover/remove-cover.component';
import { PolicySummaryComponent } from './policy-summary/policy-summary.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ProgressComponent,
    CoverageTabsComponent,
    CoverageDetailsComponent,
    PersonalDetailsComponent,
    CoverageDetailsComponent,
    NextPrevComponent,
    UnderwritingTermsComponent,
    RemoveCoverComponent,
    PolicySummaryComponent,
  ],
  exports: [
    ProgressComponent,
    CoverageTabsComponent,
    CoverageDetailsComponent,
    PersonalDetailsComponent,
    CoverageDetailsComponent,
    NextPrevComponent,
    UnderwritingTermsComponent,
    RemoveCoverComponent,
    PolicySummaryComponent,
  ],
})
export class WidgetsModule {}
